import { Button, Typography } from "antd";
import React, { useState } from "react";
import ModalOTP from "./ModalOTP";

const Index = ({
  email = "",
  partnerCode = "",
  partnerType = "",
  email_verify = null,
  isMainMarried = 0,
  setEmailToVerify = () => null,
  setEmailLocalStored = () => null, 
}) => {
  const [visible, setVisible] = useState(false);

  const storedEmail = JSON.parse(localStorage.getItem("emailLocalStored")) || {};

  const disabled = !email || email_verify === 1 || storedEmail[email] === false;

  return (
    <>
      <Typography.Text className="mr-2">
        ({partnerCode} : {email})
      </Typography.Text>
      <Button
        disabled={disabled}
        size="small"
        className={!disabled ? "bg-nn border-nn text-white" : "d-none"}
        onClick={() => setVisible(true)}
      >
        ยืนยัน
      </Button>

      {!disabled && (
        <ModalOTP
          visible={visible}
          data={{
            email,
            partner_code: partnerCode,
            partner_type: partnerType,
            is_main_married: isMainMarried,
          }}
          onCancel={() => setVisible(false)}
          onOk={() => {
            setVisible(false);

            setEmailLocalStored((e) => {
              const updated = {
                ...e,
                [email]: false,
              };
              localStorage.setItem("emailLocalStored", JSON.stringify(updated));
              return updated;
            });

            setTimeout(() => {
              setEmailToVerify(1);
            }, 300);
          }}
        />
      )}
    </>
  );
};

export default Index;
